module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAACXBIWXMAAAsSAAALEgHS3X78AAABSklEQVQ4jWPMidlrwMDAsIGBgUGegTTwkIGBIYCJTM0MUD0bmNA1x6RpgjGxhjAh8xw9ZBk4uVkZnj76AmYTA1AM4ORiYXj68DPDk4dfwGxiAE5V5raSDA7usmCDLp17w3Bgx2OG29ffY6jDasD3b78Ztq27z3Dy8HO4YakFugxrl9yGi8EAE4ZuBgawF969+cGQX20Ext+//WGY1HaOwStIEcNrWA0QEuFgyKsyBCsGYZDt377+AXtBz1iUsBeERTnBtk5sPQfmN/ZbgcVArhIW5cBtAEiTtBwPw9vX38E2B8eogsVBbHNbCQYZeV6G/Tse4/bCxTOv4U6cPeEy3CWT2s4znDz8gnAggpwIUgQLOJAXQHwQAAUgUdEIsgGkGeR8kHdA4M6ND+BoxQZABoByFUp+uHT2NRgTAR6CvBAANYRU8JCBgSEAAAGlh6YE7vAAAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/images/blix-favicon.png
// module id = 2346
// module chunks = 1